export default {"src":"/_next/static/media/mortarboard.e8856edb.svg","height":512,"width":512,"blurWidth":0,"blurHeight":0};